import * as actions from "../constants/actionTypes";

const initialState = {
    //selectedInvoice: null,
    loading: false,
    saving: false
};

export default function invoice(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_INVOICE:
            newState.loading = true;
            break;

        case actions.SAVING_INVOICE:
            newState.saving = true;
            break;

        case actions.RECEIVED_INVOICE:
            newState.loading = false;
            newState.selectedInvoice = action.payload;
            break;

        case actions.SAVED_INVOICE:
            newState.selectedInvoice = action.payload;
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_INVOICE:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.NEWLYCREATED_CLOSE_INVOICE:
            newState.selectedInvoice = null;
            break;

        case actions.REMOVED_INVOICE:
            newState.loading = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/invoice.js